document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-native-circle]');
  if (!root) return;

  const form = root.querySelector('[data-native-circle-form]');
  const friends = root.querySelector('[data-native-friends]');
  const addFriend = root.querySelector('[data-add-friend]');
  const count = root.querySelector('[data-friend-count]');
  const size = root.querySelector('[data-circle-size]');
  const message = root.querySelector('[data-native-circle-message]');
  const checkout = root.querySelector('[data-native-checkout]');
  const variantsSource = root.querySelector('[data-circle-variants]');
  if (!form || !friends || !addFriend || !count || !size || !message || !checkout || !variantsSource) return;

  const variants = JSON.parse(variantsSource.textContent || '[]');
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function friendRows() {
    return Array.from(friends.querySelectorAll('[data-friend-row]'));
  }

  function updateSummary() {
    const friendCount = friendRows().length;
    const bracelets = friendCount + 1;
    count.textContent = `(${friendCount}/5)`;
    size.textContent = `${bracelets} ${bracelets === 1 ? 'bracelet' : 'bracelets'}`;
    addFriend.hidden = friendCount >= 5;
  }

  function makeFriendRow(index) {
    const row = document.createElement('div');
    row.className = 'native-friend-row';
    row.dataset.friendRow = 'true';
    row.innerHTML = `
      <span class="native-friend-index">${String(index + 1).padStart(2, '0')}</span>
      <label><span>FRIEND’S NAME</span><input required name="friend_name" autocomplete="name" placeholder="Their name"></label>
      <label><span>FRIEND’S EMAIL</span><input required name="friend_email" type="email" inputmode="email" autocomplete="email" placeholder="friend@email.com"></label>
      <button type="button" class="native-remove-friend" aria-label="Remove friend ${index + 1}">×</button>`;
    row.querySelector('.native-remove-friend').addEventListener('click', () => {
      row.remove();
      friendRows().forEach((current, currentIndex) => {
        current.querySelector('.native-friend-index').textContent = String(currentIndex + 1).padStart(2, '0');
        current.querySelector('.native-remove-friend').setAttribute('aria-label', `Remove friend ${currentIndex + 1}`);
      });
      updateSummary();
    });
    return row;
  }

  addFriend.addEventListener('click', () => {
    const existing = friendRows();
    if (existing.length >= 5) return;
    friends.appendChild(makeFriendRow(existing.length));
    updateSummary();
    friends.querySelector('[data-friend-row]:last-child input')?.focus();
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    message.textContent = '';
    const selectedCause = window.EFP?.getCause?.();
    if (!selectedCause || selectedCause.status !== 'available') {
      message.textContent = 'This cause is still in development. Choose an available cause to build a Circle today; your selection is still counted as a signal for what we create next.';
      message.dataset.state = 'error';
      document.querySelector('[data-open-cause-picker]')?.focus();
      return;
    }
    const hostName = form.elements.host_name.value.trim();
    const hostEmail = form.elements.host_email.value.trim().toLowerCase();
    const people = friendRows().map((row) => ({
      name: row.querySelector('[name="friend_name"]').value.trim(),
      email: row.querySelector('[name="friend_email"]').value.trim().toLowerCase(),
    }));
    const emails = new Set([hostEmail]);
    const invalid = !hostName || !emailPattern.test(hostEmail) || people.some((friend) => {
      const bad = !friend.name || !emailPattern.test(friend.email) || emails.has(friend.email);
      emails.add(friend.email);
      return bad;
    });
    if (invalid) {
      message.textContent = 'Please use a name and valid email for everyone in your Circle. Each email can only appear once.';
      message.dataset.state = 'error';
      return;
    }

    const braceletCount = people.length + 1;
    const variantTitle = `${braceletCount} ${braceletCount === 1 ? 'bracelet' : 'bracelets'}`;
    const variant = variants.find((item) => item.title === variantTitle && item.available);
    if (!variant) {
      message.textContent = 'That Circle size is temporarily unavailable. Please choose fewer people or try again shortly.';
      message.dataset.state = 'error';
      return;
    }

    const properties = {
      _efp_native_circle: 'true',
      _efp_host_name: hostName,
      _efp_host_email: hostEmail,
      _efp_cause: selectedCause.name,
      _efp_color: selectedCause.colorName,
      _efp_friend_count: String(people.length),
    };
    people.forEach((friend, index) => {
      properties[`_efp_friend_${index + 1}_name`] = friend.name;
      properties[`_efp_friend_${index + 1}_email`] = friend.email;
    });

    checkout.disabled = true;
    checkout.textContent = 'MAKING YOUR CIRCLE…';
    message.textContent = 'Your Circle is being added to secure Shopify checkout.';
    message.dataset.state = 'loading';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties }] }),
      });
      if (!response.ok) {
        const detail = await response.json().catch(() => null);
        throw new Error(detail?.description || detail?.message || 'cart');
      }
      window.location.assign('/checkout');
    } catch (error) {
      checkout.disabled = false;
      checkout.textContent = 'CONTINUE TO SECURE CHECKOUT — $20 →';
      message.textContent = `Shopify could not start checkout${error instanceof Error && error.message !== 'cart' ? `: ${error.message}` : '.'} Your Circle details are still here—please try again.`;
      message.dataset.state = 'error';
    }
  });

  updateSummary();
});
